import { render, staticRenderFns } from "./Kompentensi.vue?vue&type=template&id=b3740d5c&"
import script from "./Kompentensi.vue?vue&type=script&lang=js&"
export * from "./Kompentensi.vue?vue&type=script&lang=js&"
import style0 from "./Kompentensi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports